/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import LiteVimeo from '../../public/assets/lite-vimeo-embed.min.js';
Vue.use(LiteVimeo);

import Swal from 'sweetalert2'
window.Swal = Swal
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
})

window.Toast = Toast

import helperMixins from './Mixins/HelperFunctions'
Vue.mixin(helperMixins)

import Loading from 'vue-loading-overlay'
Vue.component('loading-overlay', Loading)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('xumm-login', require('./components/XummLogin.vue').default);
Vue.component('upgrade-token', require('./components/UpgradeTokenComponent.vue').default);
Vue.component('bibliomp-layout', require('./components/BibliompLayout.vue').default);
Vue.component('wtf-nft-collections-layout', require('./components/WtfNftCollectionsLayout.vue').default);
Vue.component('megaman-xrp-layout', require('./components/MegamanXrpLayout.vue').default);
Vue.component('token-layout-component', require('./components/TokenLayoutComponent.vue').default);
Vue.component('connect-wallet', require('./components/ConnectWallet.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
